
/**
 * Форматирует дату в локализованный формат для отображения
 */
export const formatDate = (dateString?: string | Date | null): string => {
  if (!dateString) return 'Не указана';
  
  try {
    if (typeof dateString === 'string') {
      return new Date(dateString).toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } else {
      return dateString.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  } catch (error) {
    console.error('Ошибка форматирования даты:', error);
    return 'Некорректная дата';
  }
};

/**
 * Вычисляет количество оставшихся дней от текущей даты до указанной конечной даты
 */
export const getDaysRemaining = (endDateString: string): number => {
  try {
    const endDate = new Date(endDateString);
    const today = new Date();
    
    // Сбрасываем время для обеих дат, чтобы считать только полные дни
    endDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    
    // Вычисляем разницу в миллисекундах и переводим в дни
    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    // Если разница отрицательная, то срок уже истек
    return Math.max(0, diffDays);
  } catch (error) {
    console.error('Ошибка при расчете оставшихся дней:', error, endDateString);
    return 0;
  }
};

/**
 * Генерирует человекочитаемый номер сделки в формате LK-YYMMDD-XXXX для обычных клиентов
 * или VIP-YYMMDD-XXXX для VIP клиентов,
 * где XXXX - случайное число от 1000 до 9999
 */
export const generateDealNumber = (isVip: boolean = false): string => {
  const now = new Date();
  const year = now.getFullYear().toString().slice(-2);
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  const dateCode = `${year}${month}${day}`;
  
  // Генерация случайного числа от 1000 до 9999
  const randomNum = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
  
  // Используем префикс "VIP" для VIP-клиентов, иначе "LK"
  const prefix = isVip ? "VIP" : "LK";
  
  return `${prefix}-${dateCode}-${randomNum}`;
};

/**
 * Форматирует число как денежную сумму с символом валюты
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

/**
 * Рассчитывает дату следующего платежа на основе текущей даты и интервала
 */
export const calculateNextPaymentDate = (
  startDate?: Date | string | null,
  interval: 'day' | 'week' | 'month' | 'year' = 'month'
): Date => {
  const baseDate = startDate ? new Date(startDate) : new Date();
  const result = new Date(baseDate);
  
  switch (interval) {
    case 'day':
      result.setDate(result.getDate() + 1);
      break;
    case 'week':
      result.setDate(result.getDate() + 7);
      break;
    case 'month':
      result.setMonth(result.getMonth() + 1);
      break;
    case 'year':
      result.setFullYear(result.getFullYear() + 1);
      break;
  }
  
  return result;
};

/**
 * Форматирует дату в строку в формате YYYY-MM-DD для использования в API
 */
export const formatDateForApi = (date: Date): string => {
  return date.toISOString().split('T')[0];
};
